import Button from './button';

export default (props) => {
    const { children, color } = props;

    return <Button { ...props } className="button--proceed" icon='proceed' color={color}>{ children ? children : 'Proceed' }</Button>
}